module.exports = __webpack_public_path__ + "static/media/apple-icon-76x76.29bfad61.png";